<template>
      <div class="container">

        <el-row>
        <el-menu
         :unique-opened="true"
        class="el-menu-vertical-demo"
        default-active="2"
        @open="handleOpen"
        @close="handleClose"
        background-color= "#4285F4"
        text-color="#ffffff"
        active-text-color="#ffffff"
        >


       <el-menu-item index="1"
        @click="add('主页','/index')"
        >
            <i class="el-icon-s-home" style="color: #ffffff;"></i>
            <span slot="title">主页</span>
        </el-menu-item>


       <!-- <el-menu-item index="178"
        @click="add('杨经理主页','YIndex')"
        >
            <i class="el-icon-s-home"></i>
            <span slot="title">杨经理主页</span>
        </el-menu-item> -->

	  <el-submenu index="2">
	    <template slot="title">
	      <i class="el-icon-location" style="color: #ffffff;"></i>
	      <span>资产管理库</span>
	    </template>
	   <el-menu-item-group>
	        <el-menu-item index="1-1"
	        v-for="(i,index) in Property"
          :index="10+index"
	        :key="i.components"
	        @click="add(i.editableTabsValue,i.components)">
	          {{i.editableTabsValue}}</el-menu-item>
	   </el-menu-item-group>
	  </el-submenu>

   <!-- <el-menu-item index="3">
        <i class="iconfont icon-client"></i>
        <span slot="title">资产使用</span>
    </el-menu-item> -->

    <!-- <el-menu-item index="4">
        <i class="iconfont icon-tubiaozhizuomoban-108"></i>
        <span slot="title">折旧/撤销管理</span>
    </el-menu-item>

    <el-menu-item index="5">
        <i class="iconfont icon-zichanchuzhi2"></i>
        <span slot="title">资产处置</span>
    </el-menu-item>

    <el-menu-item index="6">
        <i class="iconfont icon-uniE123"></i>
        <span slot="title">资产报废</span>
    </el-menu-item> -->

<!--    <el-menu-item index="7"
    @click="add('回收站','Property_Back')"
    >
        <i class="iconfont icon-huishouzhan"></i>
        <span slot="title">回收站</span>
    </el-menu-item> -->




   <el-submenu index="8">
      <template slot="title">
        <i class="iconfont icon-goodsppeinventory" style="color: #ffffff;"></i>
        <span slot="title">资产清查</span>
      </template>
      <el-menu-item-group>
          <el-menu-item
          v-for="(k,index) in Detect"
          :index="20+index"
          :key="k.components"
          @click="add(k.editableTabsValue,k.components)">
            {{k.editableTabsValue}}</el-menu-item>

      </el-menu-item-group>
    </el-submenu>





	  <el-submenu index="9">
	    <template slot="title">
	      <i class="iconfont icon-goodsppeinventory" style="color: #ffffff;"></i>
	      <span slot="title">资产盘点</span>
	    </template>
	    <el-menu-item-group>
	         <!-- <span slot="title">项目立项模块</span> -->

	        <el-menu-item

	        v-for="(k,index) in Check"
          :index="20+index"
	        :key="k.components"
	        @click="add(k.editableTabsValue,k.components)">
	          {{k.editableTabsValue}}</el-menu-item>

	    </el-menu-item-group>
	  </el-submenu>
<!--
    <el-menu-item index="9">
        <i class="iconfont icon-pandianbaobiao"></i>
        <span slot="title">资产报表</span>
    </el-menu-item> -->

<!--    <el-menu-item index="10">
        <i class="iconfont icon-chaxunzhongxin"></i>
        <span slot="title">查询中心</span>
    </el-menu-item> -->

<!--
	  <el-menu-item index="11">
	    <i class="iconfont icon-cs-dy-1"></i>
	    <span slot="title">RFID标签打印</span>
	  </el-menu-item> -->



	  <el-submenu index="12">
	    <template slot="title">
	      <i class="iconfont icon-shezhi" style="color: #ffffff;"></i>
	      <span slot="title">设置</span>
	    </template>
	    <el-menu-item-group>

	         <el-menu-item
	         v-for="(k,index) in Munber"
           :index = "30+index"
	         :key="k.components"
	         @click="add(k.editableTabsValue,k.components)">
	           {{k.editableTabsValue}}</el-menu-item>
          <el-menu-item index="1-2" @click="Out">退出登录</el-menu-item>
	    </el-menu-item-group>
	  </el-submenu>


    </el-menu>


          </el-menu>
        </el-row>
      </div>
</template>

<script>
	// 阿里云图库的接口
  import '@/assets/Icon_New/iconfont.css';
  import '@/assets/Icon/iconfont.css';
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
    name: 'Aside',
    data () {
      return {
		// 清查页面信息
        Detect:[
			{
			  editableTabsValue:'创建清查任务',
			  components:'/DetectCreate'
			},				
          {
            editableTabsValue:'资产清查单',
            components:'/DetectIndex'
          },
          
          {
            editableTabsValue:'清查子任务',
            components:'/DetectAllDataDetail'
          },

        ],
		// 盘点所有页面信息
          Check:[
            // {
            //   editableTabsValue:'RFID标签打印',
            //   components:''
            // },
            // {
            //   editableTabsValue:'资产盘点单',
            //   components:'/CheckData'
            // },
            {
              editableTabsValue:'创建盘点单',
              components:'/CheckIndex'
            },
            {
              editableTabsValue:'资产盘点任务审核',
              components:'/CheckMission'
            },
            {
              editableTabsValue:'资产盘点异常',
              components:'/CheckErrorData'
            },
            {
              editableTabsValue:'盘点异常待审核列表',
              components:'/CheckWaitErrorData'
            },
            ],

		  // 设置页面的数据
          Munber:[
           {
              editableTabsValue:'单位信息',
              components:'/Unit'
            },
            // {
            //   editableTabsValue:'部门信息',
            //   components:'/Department'
            // },
            {
              editableTabsValue:'员工创建',
              components:'/User'
            },{
              editableTabsValue:'区域信息',
              components:'/Place'
            },{
              editableTabsValue:'资产类别信息',
              components:'/Category'
            },{
              editableTabsValue:'日志信息',
              components:'/Log'
            }],


		// 资产页面的数据
        Property:[
          // {
          //   editableTabsValue:'新建资产信息卡',
          //   components:'Property_Insert'
          // },
          {
             editableTabsValue:'资产库信息卡',
             components:'/PropertyIndex'
           },

          // {
          //    editableTabsValue:'资产批量入库',
          //    components:'Property_Insert_More'
          //  },
          {
            editableTabsValue:'资产使用',
            components:'/PropertySet'
          },
          {
            editableTabsValue:'资产变更',
            components:'/PropertyMyChange'
          },


          {
            editableTabsValue:'资产处置',
            components:'/PropertyInsertData'
          },
          // {
          //   editableTabsValue:'资产领用&退还',
          //   components:'Property_Get'
          // }
          // {
          //   editableTabsValue:'所有信息卡变动',
          //   components:'Property_Change'
          // },



          // {
          //   editableTabsValue:'信息卡报废',
          //   components:'Property_Deal'
          // },
          {
            editableTabsValue:'资产维保',
            components:'/PropertyMaintenance'
          },
          {
            editableTabsValue:'回收站',
            components:'/PropertyBack'
          },
          // {
          //   editableTabsValue:'信息卡设置',
          //   components:'Property_Set'
          // },
          // {
          //   editableTabsValue:'资产入库记录',
          //   components:'Property_Insert_Record'
          // },
          ],






        Wait:[
        {
          editableTabsValue:'待办事项',
          components:'Wait_Deal'
        },{
          editableTabsValue:'已完成的',
          components:'Finaish'
        },{
          editableTabsValue:'我申请的',
          components:'Wait_Apply'
        },{
          editableTabsValue:'已抄送的',
          components:'Copy'
        },
        ],
        isCollapse: true
      }
    },
    methods: {
		
	  // 所有的侧边栏都是把所点击到的数据传入add里面然后调用Wait_Index.vue中的addTab方法来变换页面和增加tab块
	  // 所有的targetName都是页面的汉字名称，所有格的components都是路由路径
	  // targetName对应每一个数据库里的editableTabsValue
	  // components对应每一个数据库里的components
      add(targetName,components) {
          this.$parent.$parent.$parent.$parent.addTab(targetName,components)
      },

      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
			// 登录退出接口,成功之后抹杀所有Cookies里的数据
      Out(){
			sessionStorage.clear();
			Cookies.remove('Authorization');
		    Cookies.remove('UserName');
		    Cookies.remove('Sex');
		    Cookies.remove('ID');
		    Cookies.remove('DeptId');
		    Cookies.remove('Email');
		    Cookies.remove('HeadImg');
		    Cookies.remove('Phone');
		    Cookies.remove('Remark');
		    Cookies.remove('Role_id');
		    Cookies.remove('Status');
		    this.$router.push({ path:'/'})
	
         // this.axios({
         //     method: 'GET',
         //     url: '/logout',
         //     header:{
         //      'Authorization':authorization,
         //     	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
         //     	}
         //   }).then((resp)=>{
         //     Cookies.remove('Authorization');
         //     Cookies.remove('UserName');
         //     Cookies.remove('Sex');
         //     Cookies.remove('ID');
         //     Cookies.remove('DeptId');
         //     Cookies.remove('Email');
         //     Cookies.remove('HeadImg');
         //     Cookies.remove('Phone');
         //     Cookies.remove('Remark');
         //     Cookies.remove('Role_id');
         //     Cookies.remove('Status');
         //     this.$router.push({ path:'/'})
         //   })
      }
    }
  }
</script>

<style scoped>
  .container{
    background: #4285F4;
    width: 225px;
  }
  .LogoPic{
    width: 75px;
    height: 75px;
    margin-left: 25%;
  }
  
  .el-menu{
    text-align: left;
    border-right:#e6e6e6;
    width: 226px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tool/Aside.vue